import { useState, useContext, useEffect } from "react"
import { CMultiSelect, CToggle, CheckPermission, TablePage, toast, CSelect, CSkeletonTable, ModalDelete, TablePagination, CModal, ModalFilterUser, CommaFire } from "../../components/widget"
import { ContextNav, ContextAbsence, ContextLoading, ContextDashboard } from "../../context";
import { ModuleApi, BuyModuleApi } from "../../api";
import { Link } from 'react-router-dom'
import moment from "jalali-moment";


export const Module = () => {
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const [tableData, setTableData] = useState<any>([])
    const col: any = [
        {
            title: "نام ماژول  ",
            render: (i: any) => (<div className="h-[40px] flex items-center">{i.name && i.name != null && i.name}</div>)
        },
        {
            title: "وضعیت ",
            render: (i: any) => (
                <>
                    {(i.company_has_this_module == true && i.company_expire_date_for_this_moule != null) ?
                        <>
                            {new Date(i?.company_expire_date_for_this_moule).getTime() >= new Date(moment().locale('fa').format('YYYY/M/D')).getTime() ?
                                <span>فعال</span>
                                :
                                <span>منقضی شده</span>
                            }
                        </>
                        :
                        <span>غیرفعال</span>
                    }
                </>
            )
        },
        {
            title: "قیمت پایه ",
            render: (i: any) => (<>{i.price && i.price != null && CommaFire(i.price)} تومان</>)
        },
        {
            title: "قیمت برای شما ",
            render: (i: any) => (
                <>
                    {(i.company_has_this_module == true && i.company_expire_date_for_this_moule != null) ?
                        <>
                            {new Date(i?.company_expire_date_for_this_moule).getTime() >= new Date(moment().locale('fa').format('YYYY/M/D')).getTime() ?
                                <span>قبلا خریداری شده</span>
                                :
                                <span>{i.price_based_on_current_plan && i.price_based_on_current_plan != null && CommaFire(i.price_based_on_current_plan)} تومان</span>
                            }
                        </>
                        :
                        <span>{i.price_based_on_current_plan && i.price_based_on_current_plan != null && CommaFire(i.price_based_on_current_plan)} تومان</span>
                    }
                </>
            )
        },
        {
            title: "خرید",
            render: (i: any) => (
                <>
                    {(i.company_has_this_module == true && i.company_expire_date_for_this_moule != null) ?
                        <>
                            {new Date(i?.company_expire_date_for_this_moule).getTime() >= new Date(moment().locale('fa').format('YYYY/M/D')).getTime() ?
                                <div className='w-full flex items-center justify-center'>{i.company_expire_date_for_this_moule}</div>
                                :
                                <button onClick={() => handelBuyModule(i.id)} className='w-[100px] h-[40px] border sm:mt-0 mt-3 flex items-center justify-center text-[11px] text-white rounded-lg bg-dayan-gray-200 cursor-pointer m-auto'>تمدید افزونه</button>
                            }
                        </>
                        :
                        <button onClick={() => handelBuyModule(i.id)} className='w-[100px] h-[40px] border sm:mt-0 mt-3 flex items-center justify-center text-[11px] text-white rounded-lg bg-dayan-gray-200 cursor-pointer m-auto'>خرید افزونه</button>
                    }
                </>
            )
        },
    ]

    const handelBuyModule = async (id: number) => {
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await BuyModuleApi(id)
        CtxLoad.setDisplayLoadingBlur(false)
        if (res.success) {
            window.location.href = res.data
        }
        else {
            toast("خطایی رخ داده است", { type: "error" })
        }
    }

    const getData = async () => {
        try {
            CtxLoad.setDisplayLoadingSkelton(true)
            let res = await ModuleApi()
            setTableData(res.data.modules)
            CtxLoad.setDisplayLoadingSkelton(false)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingSkelton(false)
        }
    }

    useEffect(() => {
        document.title = "   افزودنی ها | دایان"
        CtxNav.setActiveMenuItem({ 'item': 7, 'subItem': 0, })
        getData()

    }, [])

    return (
        <div className=" w-full flex flex-col">

            <div className=" w-full flex md:flex-row flex-col items-center justify-between  mt-[7px] md:mt-[25px]">
                <h1 className="sm:text-2xl text-lg font-bold mb-[30px] md:mb-0">افزودنی ها</h1>
                <div className=" w-full md:w-fit flex items-center md:mt-0 mt-[7px]">

                </div>
            </div>

            {CheckPermission(32) &&
                <div className=" w-full mt-[20px]">
                    {CtxLoad.displayLoadingSkelton == false ?
                        <TablePage columns={col} data={tableData} />
                        :
                        <CSkeletonTable />
                    }
                </div>
            }


        </div>
    )
}
